import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
export function About() {
  return <section className="py-24 bg-brand-purple text-white relative overflow-hidden" data-id="element-7">
      {/* Decorative Circles */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-brand-pink rounded-full mix-blend-multiply filter blur-3xl opacity-50 animate-pulse" data-id="element-8"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-brand-lime rounded-full mix-blend-multiply filter blur-3xl opacity-50 animate-pulse" data-id="element-9"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10 text-center" data-id="element-10">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brand-navy/40 backdrop-blur-sm border-4 border-white/20 p-12 md:p-16" data-id="element-11">
          <h2 className="text-5xl font-display font-bold mb-8 text-brand-lime" data-id="element-12">
            Why We Exist
          </h2>

          <blockquote className="text-2xl md:text-3xl font-display leading-relaxed mb-10 italic" data-id="element-13">
            "Normal is boring. We believe video games are the ultimate art form
            for the strange, the surreal, and the sublime. We are here to
            celebrate the developers who color outside the lines."
          </blockquote>

          <div className="flex flex-col items-center gap-4" data-id="element-14">
            <div className="w-16 h-1 bg-brand-pink" data-id="element-15"></div>
            <p className="text-xl font-body" data-id="element-16">
              Curating with love from the sunny, ancient shores of
            </p>
            <div className="flex items-center gap-2 text-brand-yellow font-bold text-2xl bg-brand-navy px-6 py-2 rounded-full border-2 border-brand-yellow transform -rotate-2" data-id="element-17">
              <MapPin data-id="element-18" />
              Limassol, Cyprus
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}